import * as React from "react"
import PropTypes from "prop-types"
import Container from "../components/container"

const PageTitle = ({ title, description, className }) => {
  return (
    <div className={`bg-blue-50 ${!!className ? className : null}`}>
      <Container className="pt-9 pb-9 lg:pt-14 lg:pb-14">
        <h1 className="lg:text-4xl text-2xl font-bold text-brandNavy tracking-widest">
          {title}
        </h1>
        {description ? (
          <p className="pt-3 text-textGray-100 text-sm tracking-wider">
            {description}
          </p>
        ) : null}
      </Container>
    </div>
  )
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  className: PropTypes.string,
}

export default PageTitle
